/*
  VantaTape global helpers
  - VantaTape.formatMoney: Shopify money formatting using the store's money format
  - Header background transition on scroll
  - Accessible single-open accordion (FAQ)
*/
(function () {
  window.VantaTape = window.VantaTape || {};

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = typeof precision === 'undefined' ? 2 : precision;
    thousands = thousands || ',';
    decimal = decimal || '.';
    if (isNaN(number) || number === null) return '0';
    var fixed = (number / 100.0).toFixed(precision);
    var parts = fixed.split('.');
    var units = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
    var fraction = parts[1] ? decimal + parts[1] : '';
    return units + fraction;
  }

  window.VantaTape.formatMoney = function (cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    cents = Number(cents);
    var formatString = format || window.moneyFormat || '{{amount}}';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var match = formatString.match(placeholderRegex);
    var value = '';
    switch (match ? match[1] : 'amount') {
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_with_apostrophe_separator':
        value = formatWithDelimiters(cents, 2, "'", '.');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ', '');
        break;
      case 'amount_with_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', ',');
        break;
      case 'amount_with_period_and_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', '.');
        break;
      default:
        value = formatWithDelimiters(cents, 2);
    }
    return formatString.replace(placeholderRegex, value);
  };

  /* Header: transparent at top, solid after 40px of scroll */
  function initHeaderScroll() {
    var header = document.querySelector('.header-wrapper');
    if (!header) return;
    var ticking = false;
    var threshold = 40;
    function apply() {
      var scrolled = (window.pageYOffset || document.documentElement.scrollTop) > threshold;
      header.classList.toggle('vt-header--scrolled', scrolled);
      ticking = false;
    }
    window.addEventListener(
      'scroll',
      function () {
        if (!ticking) {
          window.requestAnimationFrame(apply);
          ticking = true;
        }
      },
      { passive: true }
    );
    apply();
  }

  /* Accordion: <details> groups where only one item stays open */
  function initAccordions() {
    document.querySelectorAll('[data-vt-accordion]').forEach(function (group) {
      if (group.dataset.vtAccordionReady) return;
      group.dataset.vtAccordionReady = 'true';
      var items = Array.prototype.slice.call(group.querySelectorAll('details'));
      items.forEach(function (item) {
        var summary = item.querySelector('summary');
        if (!summary) return;
        summary.setAttribute('aria-expanded', item.hasAttribute('open') ? 'true' : 'false');
        item.addEventListener('toggle', function () {
          summary.setAttribute('aria-expanded', item.open ? 'true' : 'false');
          if (item.open && group.dataset.vtAccordion === 'single') {
            items.forEach(function (other) {
              if (other !== item && other.open) other.removeAttribute('open');
            });
          }
        });
      });
    });
  }

  function init() {
    initHeaderScroll();
    initAccordions();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', initAccordions);
})();
